// import React from 'react';
// import ReactDOM from 'react-dom';
// import './index.css';
// import App from './App';
// import reportWebVitals from './reportWebVitals';

// ReactDOM.render(
//   <React.StrictMode>
//     <App />
//   </React.StrictMode>,
//   document.getElementById('root')
// );

// // If you want to start measuring performance in your app, pass a function
// // to log results (for example: reportWebVitals(console.log))
// // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();


import React, { Component } from 'react';
import { render } from 'react-dom'
import { Router, browserHistory } from 'react-router';
import { Provider } from 'react-redux';
import Routes from './js/routes.js';
import clientStore from './js/clientStore.js';

const appName = 'NutrifyApp';

require('./styles/all.scss');
require('./styles/style.scss');

window.addEventListener('DOMContentLoaded', () => {
  let container = document.getElementById('app_container');
  render(
    <Provider store={clientStore}>
      {Routes}
    </Provider>, container);
});
